interface IData {
  partnerId: string
  expressName: string
  monthCount: string
  bigCustomerNum: string
  mobile: string
  mobile_code: string
  password: string
  img_code: string
  siteCode: string
  siteName: string
  customerPlatformId: string
  customerPlatformYzm: string
  customerBusinessId: string
  receiveCourier: string
  siteCodeList: string[]
}
export const initFormData: IData = {
  partnerId: "",
  expressName: 'ZTO|中通快递',
  monthCount: '',
  bigCustomerNum: '',
  mobile:"",
  mobile_code:"",
  img_code: '',
  password: "",
  siteCode: "",
  siteName: '',
  customerPlatformId: '',
  customerPlatformYzm: '',
  customerBusinessId: '',
  receiveCourier: '',
  siteCodeList: []
};
export const PLATFORM_TYPE = {
  OFFLINE: 'LocalOffline',
  TAO_BAO: 'TaoBao',
  TIAN_MAO: 'Tmall',
  // 鲁班(抖音)
  LU_BAN: 'LuBan',
  PDD: 'Pdd',
  KUAI_SHOU: 'KuaiShou',
  JD: 'Jd',
  YOU_ZAN: 'YouZan',
  V_DIAN: 'Vdian',
  OPEN_KDGJ: 'OpenKDGJ',
  PDD_AGENT: 'PddAgent',
  BEI_BEI: 'BeiBei',
  YOU_LIANG: 'YouLiang',
  MO_GU_JIE: 'MoGuJie',
  MEI_LI_SHUO: 'MeiLiShuo',
  GOME: 'Gome',
  ZHE_800: 'Zhe800',
  JUAN_PI: 'JuanPi',
  PIN_JUN: 'Pjun',
  DAI_FA: 'DaiFa'
}
export const PLATFORM_AUTHORIZE_LINK = {
  [PLATFORM_TYPE.TAO_BAO]: `https://oauth.taobao.com/authorize?response_type=code&client_id=21600411&redirect_uri=${window.location.origin}/Home/TaoBaoIndex&view=web&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.TIAN_MAO]: `https://oauth.taobao.com/authorize?response_type=code&client_id=21600411&redirect_uri=${window.location.origin}/Home/TaoBaoIndex&view=web&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.JD]: `https://open-oauth.jd.com/oauth2/to_login?app_key=F62A845AF102BA6FEC4F770188FA949C&response_type=code&redirect_uri=${window.location.origin}/Home/JdIndex&scope=snsapi_base&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.V_DIAN]: `https://api.vdian.com/oauth2/authorize?appkey=665656&redirect_uri=${window.location.origin}/Home/VdianIndex&response_type=code&state=\${sessionId}_Auth`,
  [PLATFORM_TYPE.YOU_LIANG]: `https://openapi.wdwd.com/oauth/authorize?response_type=code&client_id=hhj2dea3&redirect_uri=${window.location.origin}/Home/YouLiangIndex&timestamp=111&view=zto&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.GOME]: `http://oauth.gome.com.cn/authorize?response_type=code&client_id=3a61fc6026f14b8eb0fb31bf6b14162e&redirect_uri=${window.location.origin}/Home/GomeIndex&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.YOU_ZAN]: 'https://yingyong.youzan.com/center/my-apps',
  [PLATFORM_TYPE.BEI_BEI]: 'http://api.open.beibei.com/outer/oauth/app.html?app_id=eiaa&params=${sessionId}%7cAuth',
  [PLATFORM_TYPE.MO_GU_JIE]: `https://oauth.mogujie.com/authorize?response_type=code&app_key=100369&redirect_uri=${window.location.origin}/Home/MoGuJieIndex&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.MEI_LI_SHUO]: `https://oauth.meilishuo.com/authorize?response_type=code&app_key=100380&redirect_uri=${window.location.origin}/Home/MeiLiShuoIndex&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.ZHE_800]: `https://openapi.zhe800.com/oauth/code?response_type=code&client_id=ZWQ0NjhhM2YtMGU3&redirect_uri=${window.location.origin}/Home/Zhe800Index&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.PDD]: `http://mms.pinduoduo.com/open.html?response_type=code&client_id=924e0205cc6745a7a4da89e27e8cc716&redirect_uri=${window.location.origin}/Home/PddIndex&state=\${sessionId}`,
  [PLATFORM_TYPE.KUAI_SHOU]:
    `https://s.kwaixiaodian.com/oauth/authorize?app_id=ks650488674657449047&scope=user_info,merchant_user,merchant_item,merchant_order,merchant_refund&response_type=code&redirect_uri=${window.location.origin}/Home/KuaiShouIndex&state=\${sessionId}%7cAuth`,
  [PLATFORM_TYPE.LU_BAN]: 'https://fuwu.jinritemai.com/authorize?service_id=50&state=${sessionId}'
}
